import { IUseGraphqlWatchQueryOptions } from '@proscom/prostore-apollo-react';
import { useAuthGraphqlQuery } from '../../../common/hooks/utils/useAuthGraphqlQuery';
import { QUERY_GET_VACATION_BALANCE } from '../../queries/vacations';
import { PositionBalanceType } from '../../types';

const queryOptions: IUseGraphqlWatchQueryOptions<
  null,
  PositionBalanceType[]
> = {
  query: QUERY_GET_VACATION_BALANCE,
  mapData: (result) => result.vacationBalances
};

export function useVacationBalances() {
  return useAuthGraphqlQuery({
    queryOptions
  });
}
